import {
  Box,
  Flex,
  Image,
  Text,
  useColorMode,
  chakra,
  shouldForwardProp,
  useColorModeValue,
  AbsoluteCenter,
} from "@chakra-ui/react";
import React, { useCallback, useMemo, useState } from "react";
import {
  Link,
  NavLink,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isValidMotionProp, motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import useDeviceType from "../../hook/useDeviceType";
import { pcMenu } from "./helper/headerMenu";
import useCheckLogin from "../../hook/useCheckLogin";
import { COMMON_WEB_PATH } from "../../constant";
import useSound from "../../hook/useSound";
import i18next from "i18next";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const MenuPC = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const i18n_header = (key) => t(`header.${key}`);

  const borderColor = useColorModeValue("#707070", "#FAFAFA");
  const { colorMode } = useColorMode();

  const deviceType = useDeviceType();
  const { isMachineUser } = useCheckLogin();

  const location = useLocation();
  const { pathname } = location;
  const currentPath = useMemo(() => {
    const paths = pathname.split("/").filter(Boolean); // 過濾空字串
    return paths[0] || "/"; // 如果是空的（首頁），返回 '/'
  }, [pathname]);

  const playButtonSound = useSound();
  const hoverButtonSound = useSound({
    customSound: "slide_sound",
    volume: 0.3,
  });

  const animationProps = useMemo(() => {
    if (deviceType) {
      return deviceType === "PC"
        ? {
            initial: { x: "0%" },
            animate: { x: "0%" },
            exit: { x: "0%" },
            transition: { duration: 0.15, ease: "easeInOut" },
          }
        : {
            initial: { x: "-100%" },
            animate: { x: "0%" },
            exit: { x: "-100%" },
            transition: { duration: 0.15, ease: "easeInOut" },
          };
    }
  }, [deviceType]);

  const isStickyLeft = useSelector((state) => state.isStickyLeft);

  return (
    <ChakraBox
      h={`100%`}
      position={isStickyLeft ? "fixed" : "relative"}
      left="0px"
      pb={{ base: "0px" }}
      {...animationProps}
    >
      <Flex
        w={{
          base: "285px",
          md: "100%",
          lg: "100%",
        }}
        h={"calc(100% - 0px)"}
        bg="transparent"
        direction={`column`}
        alignItems={`center`}
        gap={{
          base: "10px",
          lg: "25px",
        }}
        pb="20px"
        // mt="20px"
        onClick={(event) => {
          event.stopPropagation();
        }}
        overflowY="scroll"
        overflowX="hidden"
        className="no-scrollbar"
        position="fixed"
        bgImage={`${COMMON_WEB_PATH}/now888/gameType/game_type_ribbon.png`}
        bgPos="center"
      >
        <Flex
          w="100%"
          direction={`column`}
          alignItems={`center`}
          px="10px"
          gap="0px"
        >
          {pcMenu.map((item, index) => {
            return (
              <Box
                role="group"
                as={NavLink}
                onClick={playButtonSound}
                onMouseEnter={hoverButtonSound}
                key={item.text}
                to={item.link}
                display="flex"
                flexDirection={"column"}
                alignItems={index % 2 == 0 ? "flex-end" : "flex-start"}
                justifyContent="center"
                gap="5px"
                position="relative"
                w="100%"
              >
                {(props) => {
                  const isActive = props.isActive;

                  return (
                    <Flex
                      direction="column"
                      align="center"
                      justify="flex-start"
                      w={{
                        base: "250px",
                      }}
                      minH={{
                        base: isMachineUser ? "145px" : "145px",
                      }}
                      // borderRadius="full"
                      bgImage={`url(${COMMON_WEB_PATH}/now888/gameType${
                        i18next.language == "tw" ? "" : `/${i18next.language}`
                      }/${item.text?.toUpperCase()}${
                        isActive ? `_active_` : ""
                      }.png)`}
                      _hover={{
                        bgImage: `url(${COMMON_WEB_PATH}/now888/gameType${
                          i18next.language == "tw" ? "" : `/${i18next.language}`
                        }/${item.text?.toUpperCase()}_active_.png)`,
                      }}
                      // transition={`all 0.3s`}
                      bgSize="100% 110%"
                      position="relative"
                      role="group"
                    ></Flex>
                  );
                }}
              </Box>
            );
          })}
        </Flex>
      </Flex>
    </ChakraBox>
  );
};

export default MenuPC;
